import { uuidv4 } from "@lib/uuidHelper";

import type { AgenticAiState } from "./types";

export const initialAgenticAiState: AgenticAiState = {
  context: {},
  contextIdentifiers: {},
  isOpen: false,
  sessionId: uuidv4(),
  frontendTools: {},
  frontendToolNames: {},
  liquidFields: {},
  supportEntryPoint: false,
};
